import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-16"
}
const _hoisted_2 = { class: "ion-no-margin small" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_dynamicSkeleText = _resolveComponent("dynamicSkeleText")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.storeLocation?.isTempClosed && !_ctx.storeLocation.storeStatus.isRedRobinStore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "ion-text-center" }, "This Donatos Offers", -1)),
          (_ctx.storeLocation?.displayOrderTypes)
            ? (_openBlock(), _createBlock(_component_ion_row, {
                key: 0,
                class: "ion-justify-content-evenly"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeLocation?.displayOrderTypes, (type) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      key: type.id
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          "aria-label": type.icon,
                          ios: type.icon,
                          md: type.icon,
                          color: "dark"
                        }, null, 8, ["aria-label", "ios", "md"]),
                        _createElementVNode("p", _hoisted_2, _toDisplayString(type.display), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_ion_row, {
                key: 1,
                class: "ion-justify-content-evenly"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(2), (i) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      class: "ion-text-center",
                      size: "2",
                      key: i
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_dynamicSkeleText, { childElements: [{ image: true }, { width: 85 }] })
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    (_ctx.storeLocation.storeStatus.isRedRobinStore)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
          _createElementVNode("h4", { class: "ion-text-center" }, "This Red Robin Offers Donatos", -1)
        ])))
      : _createCommentVNode("", true)
  ], 64))
}